import {
  useContext,
  lazy,
  FC,
  Suspense,
  useEffect,
  useRef,
  useState,
} from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';
import AccordionContent from './AccordionContent';
const PlotInfoContent = lazy(() => import('./PlotInfoContent'));
type Props = {
  label: string;
  id: string;
};

const PlotInfo: FC<Props> = ({ label, id }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const contentDiv = useRef<HTMLDivElement>(null);
  const [prevHeight, setPrevHeight] = useState<string>('0');
  const [height, setHeight] = useState<string>();
  const { accordionOption, setAccordionOption } = useContext(ObjectPageContext);

  useEffect(() => {
    if (contentDiv.current) {
      let contentHeight = isExpanded
        ? `${contentDiv.current.scrollHeight}px`
        : '0px';
      setPrevHeight(contentHeight);
      setHeight(contentHeight);
    }
    if (isExpanded) {
      setTimeout(() => {
        setHeight('auto');
      }, 200); //this must be same as transition duration
    } else {
      setHeight(prevHeight);
      setTimeout(() => {
        setHeight('0px');
      }, 10);
    }
  }, [isExpanded]);

  useEffect(() => {
    if (accordionOption === id) {
      setIsExpanded(true);
    }
  }, [accordionOption, id]);
  return (
    <div id={id} className="accordion">
      <AccordionContent
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        setAccordionOption={setAccordionOption}
        label={label}
      />
      <div
        ref={contentDiv}
        style={{ height: height }}
        className={`overflow-hidden transition-height ease duration-200`}
      >
        {isExpanded && (
          <Suspense>
            <PlotInfoContent />
          </Suspense>
        )}
      </div>
    </div>
  );
};

export default PlotInfo;
